import * as React from 'react';
import { createTheme, styled } from '@mui/material/styles';
//import DashboardIcon from '@mui/icons-material/Dashboard';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';

//import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ChurchIcon from '@mui/icons-material/Church';
import { Link } from "react-router-dom";

//import BarChartIcon from '@mui/icons-material/BarChart';
import MovieIcon from '@mui/icons-material/Movie';

//import DescriptionIcon from '@mui/icons-material/Description';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';

//import LayersIcon from '@mui/icons-material/Layers';
import CelebrationIcon from '@mui/icons-material/Celebration';

import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { PageContainer } from '@toolpad/core/PageContainer';
import PaletteIcon from '@mui/icons-material/Palette';
import RadioIcon from '@mui/icons-material/Radio';
import CultHistory from './CultHistory';
import CultReligious from './CultReligious';


import Grid from '@mui/material/Grid';
import CultFestival from './CultFestival';
import Footer from '../components/Footer';
import LandingSection from '../components/LandingSection';
import ActionButton from '../utils/ActionButton';

const NAVIGATION = [
  {
    kind: 'header',
    title: 'Main items',
  },
  {
    segment: 'dashboard',
    title: 'History and Heritage',
    icon: <HistoryEduIcon />,
  },
  {
    segment: 'orders',
    title: 'Religion',
    icon: <ChurchIcon />,
  },
//   {
//     kind: 'divider',
//   },
//   {
//     kind: 'header',
//     title: 'Analytics',
//   },
  
  {
    segment: 'integrations',
    title: 'Festivals & Events',
    icon: <CelebrationIcon />,
  },
];

const demoTheme = createTheme({
  colorSchemes: { light: true, dark: false },
  cssVariables: {
    colorSchemeSelector: 'class',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});

function useDemoRouter(initialPath) {
  const [pathname, setPathname] = React.useState(initialPath);

  const router = React.useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path)),
    };
  }, [pathname]);

  return router;
}

const Skeleton = styled('div')(({ theme, height }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  height,
  content: '" "',
}));

export default function DashboardLayoutBasic(props) {
  const { window } = props;

  const router = useDemoRouter('/dashboard');
  const { pathname } = router;
  let ContentComponent;
  switch (pathname) {
    case '/integrations':
      ContentComponent = CultFestival;
      break;
    case '/orders':
      ContentComponent = CultReligious;
      break;
    case '/dashboard':
    default:
      ContentComponent = CultHistory;
  }

  // Remove this const when copying and pasting into your project.
  const demoWindow = window ? window() : undefined;
  const routeMeta = {
    '/dashboard': {
      title: 'History and Heritage',
      breadcrumbs: [
        { title: 'Home', path: '/' },
        { title: 'Culture', path: '/culture' },
      ],
    },
    '/orders': {
      title: 'Religion',
      breadcrumbs: [
        { title: 'Home', path: '/' },
        { title: 'Culture', path: '/culture' },
      ],
    },
    '/integrations': {
      title: 'Festivals and Events',
      breadcrumbs: [
        { title: 'Home', path: '/' },
        { title: 'Culture', path: '/culture' },
      ],
    },
    // Add more as needed
  };
  const pageInfo = routeMeta[pathname] || {
    title: 'Page',
    breadcrumbs: [],
  };
  
  

  return (
    <div>
    <LandingSection
        data={{ imageName: "utahculture.webp", title: "Utah Culture", visible:"" }}
      />



<div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah’s Culture</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
            Explore local arts, history, values, and traditions that shape Utah’s cultural identity.

            </p>
             <Link to={"/about"}>
            {/* <ActionButton data="Know More About Us" /> */}
            </Link>
          </div>
        </div>
      </div>


    <div style={{ marginTop: '2rem' }}>
  <AppProvider navigation={NAVIGATION} router={router} theme={demoTheme} window={demoWindow}>
    <DashboardLayout
      sx={{
        width: '100%',
        maxWidth: '100vw',
        margin: '0 auto',
        padding: '0',
        boxShadow: 'none',
        backgroundColor: 'transparent',
      }}
    >
     <div
    style={{
      position: 'absolute',
      top: 0,
      left: 105,
      padding: '16px',
      fontSize: '1.25rem',
      fontWeight: 'bold',
      zIndex: 1301, // higher than MUI AppBar
    }}
  >
    Utah Culture
  </div>

  <style>
    {`
      [class*="MuiAppBar-root"] .MuiTypography-root {
        visibility: hidden;
      }
    `}
  </style>

  {/* <style>
        {`
        
          .MuiAppBar-root .MuiToolbar-root .MuiIconButton-root {
            visibility: hidden;
          }
        `}
      </style> */}
      <PageContainer
        title={pageInfo.title}
        breadcrumbs={pageInfo.breadcrumbs}
        slots={{
          header: (props) => (
            <div style={{ padding: '1rem' }}>
              <h1 style={{ color: '#2e2e2e', fontSize: '2rem' }}>{props.title}</h1>
            </div>
          ),
        }}
      >
        <ContentComponent />
      </PageContainer>
    </DashboardLayout>
  </AppProvider>
</div>

    <Footer/>
    
    </div>
  );
}
